import lf from 'lovefield'

export function simu_cubatures (schemaBuilder) {
  schemaBuilder.createTable('simu_cubatures')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_etudes_id', lf.Type.INTEGER)
      .addColumn('exo_cubatures_id', lf.Type.INTEGER)
      .addColumn('rendement', lf.Type.NUMBER)
      .addColumn('cout', lf.Type.NUMBER)
      .addColumn('qualite', lf.Type.INTEGER)
      .addColumn('securite', lf.Type.INTEGER)
      .addColumn('environnement', lf.Type.INTEGER)

      .addPrimaryKey(['id']);
      // .addIndex('simuEtudes_id', ['simuEtudes_id', 'exoCubatures_id']);

}

/*
CREATE TABLE IF NOT EXISTS `simu-cubatures` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-etudes_id` int(11) NOT NULL,
  `exo-cubatures_id` int(11) NOT NULL,
  `rendement` float NOT NULL,
  `cout` float NOT NULL,
  `qualite` int(11) NOT NULL,
  `securite` int(11) NOT NULL,
  `environnement` int(11) NOT NULL,
  PRIMARY KEY (`id`),
  KEY `simu-etudes_id` (`simu-etudes_id`,`exo-cubatures_id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuCubatures.schema.js